module.exports = "---\nurl: \"https://raw.githubusercontent.com/LexicForLXD/Backend/gh-pages/openapi.json\"\ndom_id: \"#swagger-ui\"\nvalidatorUrl: \"https://online.swagger.io/validator\"\noauth2RedirectUrl: \"http://localhost:3200/oauth2-redirect.html\"\n"


//////////////////
// WEBPACK FOOTER
// ./swagger-config.yaml
// module id = 1019
// module chunks = 0